<style lang="scss">
body {
    background: white;
    height: 100%;
    font-family: "Microsoft YaHei", sans-serif;
}
.dy_notice {
    .flex {
        display: flex;
    }

    background: white;
    .site_banner {
        background: url(../../assets/images/dy/all.png) #51b5c8 no-repeat center
            center;
        height: 300px;
        text-align: center;
        width: auto;
        background-position: 0 -1303px;
        line-height: 300px;
        img {
            vertical-align: middle;
        }
    }
    .content {
        width: 1170px;
        margin: 20px auto;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 80px 70px 80px;
        background: white;
        margin-bottom: 120px;
        border: 1px solid #f5f5f5;
        box-shadow: -3px 0 10px #ebebeb, 3px 0 10px #ebebeb, 0 -3px 10px #ebebeb,
            0 3px 10px #ebebeb;
        .annoucementForm {
            text-align: center;
            font-size: 22px;
            font-weight: 600;
            padding: 10px 0;
        }
        .noticeList {
            li {
                border-bottom: solid 1px #eee;
                padding: 10px 20px;
                line-height: 35px;
                display: flex;
                justify-content: space-between;
                &:last-child {
                    border-bottom: 0;
                }
                .dian {
                    padding-left: 15px;
                    text-align: center;
                    background: url(../../assets/images/dy/all.png);
                    height: 8px;
                    width: 10px;
                    background-position: 0 -1125px;
                    margin-top: 12px;
                }
                .title {
                    overflow: hidden;
                    width: 780px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                a {
                    display: block;
                    width: 100%;
                    color: #333;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .footer {
        width: 100%;
        position: relative;
        bottom: 0;
        text-align: center;
        border-top: solid 1px #ccc;
        line-height: 80px;
        .containerzz {
            background: url(../../assets/images/dy/all.png);
            height: 58px;
            line-height: 58px;
            width: 400px;
            background-position: 0 -1765px;
            text-align: center;
            margin: 0 auto;
            margin-top: 20px;
        }
    }
}
</style>

<template>
    <div class="dy_notice">
        <div class="site_banner">
            <img src="../../assets/images/dy/logo.png">
        </div>
        <div class="content">
            <div class="annoucementForm-box">
                <div class="annoucementForm">
                    <span class="text">考试公告</span>
                </div>
                <ul class="noticeList">
                    <template v-for="(testInform,index) in testInforms">
                        <li v-if="index<8">
                            <div class="flex">
                                <div
                                    class="dian"
                                    style="float: left"
                                ></div>
                                <router-link
                                    class="title"
                                    target="_blank"
                                    :to="{name:'default.dynotice',query:{id:testInform.id}}"
                                >
                                    {{testInform.title}}
                                </router-link>
                            </div>
                            <div>{{testInform.create_time}}</div>
                        </li>
                    </template>

                </ul>
            </div>
            <el-pagination
                @size-change="sizeChange"
                @current-change="pageIndexChange"
                :current-page.sync="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                style="float:right;padding-right:50px;padding-top:20px"
            >
            </el-pagination>
        </div>
        <div class="footer">
            <div class="containerzz">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            testInforms: [],
            pageIndex: 1,
            pageSize: 10,
            pageSizes: [5, 10, 20, 50],
            total: 0
        };
    },
    created: function() {
        this.getData();
        this.getInfo();
    },
    methods: {
        sizeChange: function(pageSize) {
            this.pageSize = pageSize;
            if (this.pageIndex === 1) {
                this.getData();
            } else {
                this.pageIndex = 1;
                this.getData();
            }
        },
        pageIndexChange: function(pageIndex) {
            this.pageIndex = pageIndex;
            this.getData();
        },
        getNormalAnn: function() {
            let url;
            url =
                "ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT";

            this.$http
                .get(globalProvider.serviceUrl(url), {
                    params: {
                        domain: "zhongxintest",
                        page_index: this.pageIndex,
                        page_size: this.pageSize,
                        n_type: "se"
                    }
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        data.body.data.map(item => {
                            if (item.type == 1) {
                                this.testInforms = item._items;
                                this.total = item.totalCount;
                                this.pageIndex = item.pageIndex;
                            }
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(
                            getErrorMessage(data.body.message),
                            "提示",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    }
                });
        },
         getkefu: function(id, type) {
            if (type == "live800") {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src =
                    "https://live800.ata-test.net.cn/live800/chatClient/staticButton.js?companyID=228&configID=" +
                    id +
                    "&codeType=steady&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script);
                var script2 = document.createElement("script");
                script2.type = "text/javascript";
                script2.src =
                    "https://live800.ata-test.net.cn/live800/chatClient/monitor.js?companyID=228&configID=1&codeType=custom&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script2);
                var script3 = document.createElement("script");
                script3.innerHTML =
                    "function writehtml(){var temptext=StaticIcon_generate();document.getElementById('live81').innerHTML=temptext;setTimeout('write.src',9000);}setTimeout('writehtml()',1500);";
                document.getElementsByTagName("head")[0].appendChild(script3);
            } else {
                let code, link;
                let kefuInfo = id.split("+");
                if (kefuInfo.length > 1) {
                    code = kefuInfo[0].toString();
                    link = kefuInfo[1].toString();
                }
                //udesk
                let udeskScript = document.createElement("script");
                udeskScript.type = "text/javascript";
                udeskScript.innerHTML = `(function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,"script","https://assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
ud({
    "code": '${code}',
    "link": '${link}',
});
`;
                document
                    .getElementsByTagName("head")[0]
                    .appendChild(udeskScript);
            }
        },
        getInfo: function(domain) {
            this.$http
                .get(globalProvider.serviceUrl("ea/g/pcas/{domain}"), {
                    params: {
                        domain: "zhongxintest"
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        if (data.body.data) {
                            if (data.body.data.online_chat) {
                                this.getkefu(
                                    data.body.data.online_chat,
                                    data.body.data.chat_type
                                );
                            }
                        }
                    } else
                        this.$router.push({
                            name: "default.notFound"
                        });
                });
        },
        getData() {
            this.getNormalAnn();
        }
    }
};
</script>


